import { render } from "./BetsTable.vue?vue&type=template&id=42d1f8ce&scoped=true"
import script from "./BetsTable.vue?vue&type=script&lang=js"
export * from "./BetsTable.vue?vue&type=script&lang=js"

import "./BetsTable.vue?vue&type=style&index=0&id=42d1f8ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d1f8ce"]])

export default __exports__